export default {
  navbar: {
    home: 'Home',
    jobs: 'Jobs',
    companies: 'Companies',
    about: 'About Us',
    customerService: 'Customer Service',
    signIn: 'Sign In',
    register: 'Register'
  },
  customerService: {
    title: 'Contact Customer Service',
    subtitle: 'Our professional support team is always here for you, 24/7 online to answer your questions.',
    onlineService: 'Online Service',
    serviceDescription: 'Our professional support team is always here for you, 24/7',
    startChat: 'Start Online Chat',
    responseTime: 'Average response time: 30 seconds',
    instantResponse: 'Instant Response',
    instantResponseDesc: 'Our customer service team is online 24/7, with an average response time of less than 2 minutes',
    professionalTeam: 'Professional Team',
    professionalTeamDesc: 'Rigorously trained customer service personnel familiar with all business processes',
    securityPrivacy: 'Security & Privacy',
    securityPrivacyDesc: 'All your information is encrypted to ensure absolute security',
    serviceOnline: 'Service Online',
    seniorConsultant: 'Senior Customer Consultant'
  },
  home: {
    heroTitle: 'Find Your Dream Job in the Film Industry',
    heroSubtitle: 'Connect with top cinemas and entertainment companies. Start your journey in the exciting world of cinema today.',
    popularCategories: 'Popular Job Categories',
    categoriesDescription: 'Explore opportunities in various film and entertainment fields',
    featuredJobOpportunities: 'Featured Job Opportunities',
    discoverLatestOpenings: 'Discover the latest openings at top cinemas',
    openPositions: 'open positions',
    quickApply: 'Quick Apply',
    whyChooseUs: 'Why Choose Us',
    joinLargestNetwork: 'Join the largest network of film professionals',
    categories: {
      theaterOperations: {
        title: 'Cinema Operations',
        description: 'Manage daily cinema operations to ensure smooth screenings'
      },
      boxOfficeManagement: {
        title: 'Box Office Management',
        description: 'Handle ticket sales and customer service at the box office'
      },
      cinemaTechnology: {
        title: 'Cinema Technology',
        description: 'Maintain and operate advanced cinema equipment and systems'
      },
      customerService: {
        title: 'Customer Service',
        description: 'Provide excellent service to cinema audiences'
      },
      foodBeverage: {
        title: 'Food & Beverage',
        description: 'Manage concession stand and food service operations'
      },
      marketingPromotions: {
        title: 'Marketing & Promotions',
        description: 'Create and execute marketing strategies for cinemas'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: 'Cinema Manager',
        company: 'AMC Theatres',
        location: 'New York, NY',
        type: 'Full-time',
        salary: '$65K - $85K',
        benefit: 'Benefits'
      },
      digitalProjectionist: {
        title: 'Digital Projectionist',
        company: 'Regal Cinemas',
        location: 'Los Angeles, CA',
        type: 'Full-time',
        salary: '$45K - $60K',
        benefit: 'Training'
      },
      marketingCoordinator: {
        title: 'Marketing Coordinator',
        company: 'Cinemark',
        location: 'Chicago, IL',
        type: 'Full-time',
        salary: '$50K - $65K',
        benefit: 'Remote'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: 'Large Industry Network',
        description: 'Connect with over 2,500+ cinemas and entertainment companies worldwide',
        stat: '15,000+ active users'
      },
      verifiedEmployers: {
        title: 'Verified Employers',
        description: 'All employers are strictly vetted to ensure genuine opportunities',
        stat: '100% verified companies'
      },
      careerGrowth: {
        title: 'Career Growth',
        description: 'Access training resources and advancement opportunities',
        stat: '89% success rate'
      }
    }
  },
  jobs: {
    heroTitle: 'Join Our Cinema Family',
    heroSubtitle: 'Become part of the magic that brings stories to life. We are looking for passionate individuals to join our growing team.',
    viewPositions: 'View Open Positions',
    currentOpenings: 'Current Openings',
    department: 'Department',
    location: 'Location',
    applyNow: 'Apply Now',
    whyJoinUs: 'Why Join Us',
    ourCulture: 'Our Culture',
    applicationProcess: 'Application Process',
    startYourJourney: 'Start Your Journey',
    benefits: {
      freeMovieAccess: {
        title: 'Free Movies',
        description: 'Enjoy unlimited free movies for you and your family.'
      },
      careerGrowth: {
        title: 'Career Development',
        description: 'Comprehensive training and clear career progression paths.'
      },
      flexibleSchedule: {
        title: 'Flexible Schedule',
        description: 'Flexible scheduling options for work-life balance.'
      }
    },
    jobList: [
      {
        title: 'Cinema Operations Manager',
        location: 'New York, NY',
        type: 'Full-time',
        description: 'Lead daily cinema operations, ensuring our flagship location delivers exceptional customer experiences.'
      },
      {
        title: 'Senior Projectionist',
        location: 'Los Angeles, CA',
        type: 'Full-time',
        description: 'Operate and maintain digital projection systems to ensure optimal viewing experiences.'
      },
      {
        title: 'Concession Stand Team Lead',
        location: 'Chicago, IL',
        type: 'Full-time',
        description: 'Manage concession operations and lead a professional food service team.'
      },
      {
        title: 'Guest Experience Specialist',
        location: 'Miami, FL',
        type: 'Part-time',
        description: 'Provide exceptional service and create unforgettable experiences for our guests.'
      },
      {
        title: 'Technical Support Specialist',
        location: 'Seattle, WA',
        type: 'Full-time',
        description: 'Maintain and troubleshoot cinema equipment and systems.'
      },
      {
        title: 'Events Coordinator',
        location: 'Boston, MA',
        type: 'Full-time',
        description: 'Plan and execute special screenings and private cinema events.'
      }
    ],
    testimonials: [
      {
        name: 'Emily Richardson',
        position: 'Cinema Manager',
        quote: 'Working here has been an incredible journey. The growth opportunities and supportive environment make this so much more than just a job.'
      },
      {
        name: 'Michael Anderson',
        position: 'Senior Projectionist',
        quote: 'The technology and equipment we work with are state-of-the-art. For any film lover, this is a dream come true.'
      },
      {
        name: 'Sarah Martinez',
        position: 'Events Coordinator',
        quote: 'The team spirit here is amazing. We work together to create memorable experiences for our guests.'
      }
    ],
    applicationSteps: [
      {
        title: 'Apply Online',
        description: 'Submit your application through our career portal.'
      },
      {
        title: 'Initial Review',
        description: 'Our team will review your application within 48 hours.'
      },
      {
        title: 'Interview',
        description: 'Meet with our team to discuss the opportunity.'
      },
      {
        title: 'Welcome Aboard',
        description: 'Start your journey with our cinema family.'
      }
    ]
  },
  companies: {
    searchPlaceholder: 'Search companies...',
    location: 'Location',
    companySize: 'Company Size',
    industry: 'Industry',
    openPositions: 'open positions',
    viewJobs: 'View Jobs',
    loadMore: 'Load More Companies',
    companyList: [
      {
        name: 'Universal Entertainment Group',
        location: 'Los Angeles, CA',
        size: '5,000+ employees',
        description: 'Leading global entertainment company producing and distributing film and television content worldwide.'
      },
      {
        name: 'Cinemark Productions',
        location: 'New York, NY',
        size: '2,000-5,000 employees',
        description: 'Award-winning production studio specializing in blockbuster films and innovative digital content.'
      },
      {
        name: 'Digital Cinema Solutions',
        location: 'San Francisco, CA',
        size: '1,000-2,000 employees',
        description: 'Technology-driven company revolutionizing the digital cinema experience through innovative solutions.'
      },
      {
        name: 'Paramount Digital Studios',
        location: 'Chicago, IL',
        size: '500-1,000 employees',
        description: 'Creating next-generation digital entertainment experiences through cutting-edge technology.'
      },
      {
        name: 'Global Theater Networks',
        location: 'Miami, FL',
        size: '1,000-2,000 employees',
        description: 'Operating premium cinema chains with state-of-the-art facilities in major cities.'
      },
      {
        name: 'Silverscreen Technologies',
        location: 'Seattle, WA',
        size: '500-1,000 employees',
        description: 'Developing cutting-edge software solutions for the modern cinema industry.'
      }
    ]
  },
  about: {
    heroTitle: 'About Us',
    heroSubtitle: 'Where creativity meets technology, stories come to life through innovative lenses.',
    ourStory: 'Our Story',
    storyParagraph1: 'CineMaster Studio was founded in 2010 and has been at the forefront of film innovation for over a decade. Our journey began with a simple yet powerful vision: to create compelling visual stories that resonate with audiences worldwide.',
    storyParagraph2: 'Today, we are proud to be one of the leading production studios, collaborating with global brands and talented artists in the industry. Our commitment to excellence and passion for storytelling continues to drive us forward.',
    ourCoreValues: 'Our Core Values',
    creativeExcellence: 'Creative Excellence',
    creativeExcellenceDesc: 'Pushing boundaries and setting new standards in visual storytelling.',
    collaborativeSpirit: 'Collaborative Spirit',
    collaborativeSpiritDesc: 'Working together to bring unique visions to life.',
    qualityFirst: 'Quality First',
    qualityFirstDesc: 'Pursuing excellence in every frame we create.',
    meetOurTeam: 'Meet Our Team',
    creativeDirector: 'Creative Director',
    leadCinematographer: 'Lead Cinematographer',
    technicalDirector: 'Technical Director',
    productionManager: 'Production Manager',
    yearsExperience: 'years experience',
    projectsCompleted: 'projects completed',
    industryAwards: 'industry awards',
    happyClients: 'happy clients'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. All rights reserved.',
    description: 'Connecting talent with opportunities in the film industry. Find your next role in cinema operations, management, or technical positions.',
    quickLinks: 'Quick Links',
    jobSeeker: 'Job Seeker',
    newsletter: 'Newsletter',
    newsletterText: 'Subscribe to get the latest job updates and career advice.',
    emailPlaceholder: 'Your email',
    subscribe: 'Subscribe',
    quickLinksList: ['About Us', 'Contact Us', 'Privacy Policy', 'Terms of Service'],
    jobSeekerLinksList: ['Browse Jobs', 'Career Resources', 'Resume Tips', 'Job Alerts']
  }
}